<script setup lang="ts">
import { Head } from '@inertiajs/vue3'
import EstateObjectData = App.Data.EstateObject.EstateObjectData
import { useI18n } from 'vue-i18n'
import OverviewTable from '@/components/estate-objects/OverviewTable.vue'

const { t } = useI18n()

defineProps<{
  estateObjects: EstateObjectData[]
  filter?: string
}>()
</script>

<template>
  <div class="w-full">
    <Head :title="t('title')" />

    <div>
      <h1 class="text-2xl font-semibold">{{ t('title') }} • {{ t('listType.' + (filter || 'default')) }}</h1>
    </div>

    <div class="text-sm">
      <OverviewTable :estate-objects :print="true" :filter />
    </div>

    <LastPage />
  </div>
</template>

<style scoped>
a {
  text-decoration: underline;
  color: #888;
}

p {
  margin-top: 1rem;
  margin-bottom: 2rem;
  max-width: 65ch;
}
</style>

<i18n>
{
  "de": {
    "title": "Immobilienübersicht",
    "listType": {
      "default": "Alle Immobilien",
      "purchase": "Ankaufsliste",
      "portfolio": "Bestandsliste",
      "sold": "Verkaufte Immobilien",
      "all": "Alle Immobilien"
    }
  },
  "en": {
    "title": "Properties Overview",
    "listType": {
      "default": "All Properties",
      "purchase": "Purchase List",
      "portfolio": "Portfolio List",
      "sold": "Sold Properties",
      "all": "All Properties"
    }
  }
}
</i18n>
